export default __webpack_public_path__ + "static/media/Bharat.12053125.jpeg";